<template>
  <div class="documentPhoto">
    <div class="wrapper-box">
      <div v-for="(lists,index) in credentialsPhoto" :key="index">
        <div class="items-box" v-if="lists.photos.length>0">
          <div class="title">{{lists.name}}</div>
          <div class="img-box">
            <img
              :src="imgItems"
              alt
              class="imgs"
              v-for="(imgItems,idx) in lists.photos"
              :key="idx"
              @click="onDialogOpen(index,idx)"
            />
          </div>
        </div>

      </div>
    </div>
      <empty :type="3" v-if="credentialsPhoto.length === 0 && !loading"></empty>
  </div>
</template>
<script>
    import { ImagePreview } from 'vant';
    import empty from 'comps/empty';
    export default {
        components: {
            empty
        },

        data () {
            return {
                // 证件图片
                credentialsPhoto: [],
                guideId: 0
            };
        },

        computed: {},

        watch: {},

        methods: {
            onDialogOpen (index, startPosition) {
                let photos = this.credentialsPhoto[index].photos
                ImagePreview({
                    images: photos,
                    startPosition: startPosition,
                    closeOnPopstate: true,
                    onClose () {
                        // do something
                    }
                });
            }
        },

        mounted () {},
        created () {
            this.credentialsPhoto = localStorage.getItem('travelPhoto') ? JSON.parse(localStorage.getItem('travelPhoto')) : []
            console.log(this.credentialsPhoto)
            // this.credentialsPhoto = JSON.parse(this.$route.query.credentialsPhoto) || []
        }
    };
</script>
<style scoped lang="less">
.documentPhoto {
  background: @base-bgcolor;
  height: 100%;
  .backnav-box {
    height: 44px;
    background: rgba(54, 179, 116, 1);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .back-icon {
      position: absolute;
      width: 10px;
      height: 16px;
      top: 14px;
      left: 20px;
    }

    .backnav-text {
      font-size: 16px;

      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }

  .wrapper-box {
    box-sizing: border-box;
    padding: 20px 12px 0 12px;

    .items-box {
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        margin-bottom: 12px;
      }

      .img-box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .imgs {
          width: 100px;
          height: 100px;
          border-radius: 3px;
          background: #ccc;
          margin-bottom: 25px;
          object-fit: cover;
          &:nth-of-type(3n + 2) {
            margin-left: 25px;
            margin-right: 25px;
          }
        }
      }
    }
  }
}
</style>
